/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

// TODO: Refactor

import { useRef, useState, useEffect } from 'react';
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  HStack,
  Box,
  Text,
  Icon,
  Divider,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  Checkbox,
} from '@chakra-ui/react';

import { ReactComponent as FiltersIcon } from '../../../assets/icons/filters.svg';
import {
  useChangeUserPreferenceMutation,
  useGetAllActiveFormsQuery,
  useGetUserPreferenceQuery,
} from '../../../services';
import {
  FiltersOperation,
  FormFieldTypes,
  TaskDynamicColumn,
} from '../../../models';
import { QueryStatus } from '@reduxjs/toolkit/dist/query';
import {
  isMutationSuccess,
  notifyMutationFailure,
} from '../../../utils/mutation-feedback';

/**
 * Named on purpose (it used to be an inline object literal). The tasks page
 * passed `filters` / `setFilters` — the names its SIBLING drawer uses — so
 * both props arrived undefined and the drawer silently ignored the columns it
 * was handed. Naming the contract here is what makes a future rename a
 * compile error instead of another silent drop.
 */
export interface TaskDynamicColumnsDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  /** The columns currently configured, owned by the tasks page. */
  userDynamicColumns: TaskDynamicColumn[];
  /** Pushes the user's saved selection back up to the page. */
  setUserDynamicColumns: React.Dispatch<
    React.SetStateAction<TaskDynamicColumn[]>
  >;
}

export const TaskDynamicColumnsDrawer = ({
  isOpen,
  onClose,
  setUserDynamicColumns,
  userDynamicColumns,
}: TaskDynamicColumnsDrawerProps) => {
  const btnRef = useRef<HTMLElement>(null);
  const [componentScopeFilters, setComponentScopeFilters] = useState<
    TaskDynamicColumn[]
  >([]);

  const { data: formsData, status: formsStatus } = useGetAllActiveFormsQuery({
    phaseIds: undefined,
  });

  const {
    data: userPreferenceData,
    status: userPreferenceStatus,
    refetch,
  } = useGetUserPreferenceQuery();

  const [changeUserPreference, { isLoading: isChangingPreference }] =
    useChangeUserPreferenceMutation();

  // A plain function, NOT a memo: this derives a fresh array, and depending on
  // a derived array's identity inside an effect is a render loop waiting to
  // happen. Call it where the value is needed instead.
  const toPreferenceColumns = (): TaskDynamicColumn[] =>
    (userPreferenceData?.data ?? []).map(item => ({
      field: item.field,
      formTemplateId: item.tempFormId,
    }));

  // The columns the page already holds win over the server preference: they
  // are what the user last applied in this session.
  useEffect(() => {
    if (userDynamicColumns.length > 0) {
      setComponentScopeFilters(userDynamicColumns);
    }
  }, [userDynamicColumns]);

  // Fresh load, page copy still empty: fall back to the saved preference,
  // exactly as before. Keyed on the query STATUS only, for the reason above.
  useEffect(() => {
    if (
      userDynamicColumns.length === 0 &&
      userPreferenceStatus === QueryStatus.fulfilled
    ) {
      setComponentScopeFilters(toPreferenceColumns());
    }
  }, [userPreferenceStatus]);

  const resetToConfiguredColumns = () =>
    setComponentScopeFilters(
      userDynamicColumns.length > 0 ? userDynamicColumns : toPreferenceColumns()
    );

  return (
    <Drawer
      isOpen={isOpen}
      placement="right"
      onClose={onClose}
      finalFocusRef={btnRef}
      size={'lg'}
    >
      <DrawerContent>
        <DrawerHeader>
          <HStack align="center">
            <HStack>
              <Box
                borderRadius="md"
                boxShadow="0 1px 2px 0 rgba(16, 24, 40, 0.05)"
                border="1px"
                borderColor="custom_gray.4"
                px="2"
                py="1"
              >
                <Icon as={FiltersIcon} />
              </Box>
              <Text fontWeight="semibold" fontSize="md">
                Edit Tasks Columns
              </Text>
            </HStack>
            <DrawerCloseButton />
          </HStack>
        </DrawerHeader>
        <Divider />

        <DrawerBody>
          <Box>
            {formsData?.data && formsData?.data.length > 0 && (
              <Accordion allowMultiple sx={{ mt: '5' }}>
                {formsData?.data.map(form => (
                  <AccordionItem
                    key={form.name}
                    sx={{
                      mb: '4',
                      border: 'none',
                      boxShadow: '0 1px 2px 0 rgba(16, 24, 40, 0.05)',
                    }}
                  >
                    <h2>
                      <AccordionButton
                        sx={{ bg: 'custom_gray.4', borderRadius: '8px' }}
                      >
                        <Box as="span" flex="1" textAlign="left">
                          {form.name}
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel>
                      {form.fields.map(
                        field =>
                          field.type !== FormFieldTypes.separator && (
                            <Box mt="4" key={field.id}>
                              {/*
                                CONTROLLED, not `defaultChecked`: the selection
                                arrives after mount (from the page's props, or
                                from the preference query resolving), and an
                                uncontrolled checkbox reads its default exactly
                                once — so a configured column rendered
                                unchecked.
                              */}
                              <Checkbox
                                isChecked={
                                  componentScopeFilters.find(
                                    item =>
                                      item.formTemplateId === form.id &&
                                      item.field === field.title
                                  )
                                    ? true
                                    : false
                                }
                                onChange={e => {
                                  if (e.target.checked) {
                                    setComponentScopeFilters(prev => [
                                      ...prev,
                                      {
                                        formTemplateId: form.id as number,
                                        field: field.title as string,
                                      },
                                    ]);
                                  } else {
                                    let newCopyOfTheArray = [
                                      ...componentScopeFilters,
                                    ];
                                    const targetIndex =
                                      newCopyOfTheArray.findIndex(
                                        item =>
                                          item.formTemplateId === form.id &&
                                          item.field === field.title
                                      );

                                    newCopyOfTheArray.splice(targetIndex, 1);
                                    setComponentScopeFilters(newCopyOfTheArray);
                                  }
                                }}
                                colorScheme="orange"
                              >
                                {field.title}
                              </Checkbox>
                            </Box>
                          )
                      )}
                    </AccordionPanel>
                  </AccordionItem>
                ))}
              </Accordion>
            )}
          </Box>
        </DrawerBody>

        <DrawerFooter>
          <Button
            variant="outline"
            mr={3}
            onClick={() => {
              resetToConfiguredColumns();
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            isLoading={isChangingPreference}
            bg="custom_orange.2"
            _hover={{ bg: 'custom_orange.2' }}
            color="white"
            onClick={async () => {
              const response = await changeUserPreference({
                preferences: componentScopeFilters,
              });

              // JUDGMENT CALL (recorded in the ticket report): this is a
              // preference write, but it is an explicit "Apply" the user
              // clicked — not passive telemetry. Closing the drawer on a
              // rejected save told the user their columns had changed when the
              // very next render would show the old ones. Stay open and say so;
              // success behaviour (refetch, then close, no toast) is unchanged.
              if (!isMutationSuccess(response)) {
                notifyMutationFailure(response, {
                  title: 'Could not save your task columns',
                  description:
                    'Your column selection was not saved. Please try again.',
                });
                return;
              }

              // Hand the applied selection back to the page, which owns it.
              // Without this the page's copy stays empty and the drawer would
              // start from the server preference again on every open.
              setUserDynamicColumns(componentScopeFilters);

              await refetch();
              onClose();
            }}
          >
            Apply
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
